module.exports = __webpack_public_path__ + "static/media/save_card.5ef344d2.svg";